exports.API_URL = 'https://api.ringarenshotell.se/api'

// exports.API_URL = 'http://localhost:3000/api'